if (!customElements.get('bp-card-video')) {
  customElements.define('bp-card-video', class extends HTMLElement {
    connectedCallback() {
      if (this.connected) return;
      this.video = this.querySelector('video');
      this.button = this.querySelector('button');
      if (!this.video || !this.button) return;
      this.connected = true;
      this.inViewport = false;
      this.userPaused = this.userPaused ?? false;
      this.userStarted = this.userStarted ?? false;
      this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.video.muted = true;
      this.video.defaultMuted = true;
      this.video.playsInline = true;
      this.video.loop = true;
      this.updateButton = () => {
        this.dataset.paused = String(this.video.paused);
        this.button.setAttribute('aria-label', this.video.paused
          ? this.button.dataset.playLabel : this.button.dataset.pauseLabel);
      };
      this.sync = () => {
        if (!this.shouldPlay()) {
          this.video.pause();
        } else if (this.video.paused) {
          this.video.play()?.catch(this.updateButton);
        }
        this.updateButton();
      };
      this.onPause = () => {
        this.updateButton();
        if (this.shouldPlay()) requestAnimationFrame(this.sync);
      };
      this.onPlay = () => {
        if (!this.shouldPlay()) this.video.pause();
        this.updateButton();
      };
      this.onToggle = event => {
        event.preventDefault();
        event.stopPropagation();
        this.userPaused = !this.video.paused;
        this.userStarted = !this.userPaused;
        this.sync();
      };
      this.onMotionChange = () => {
        this.userStarted = false;
        this.sync();
      };
      this.button.addEventListener('click', this.onToggle);
      this.video.addEventListener('pause', this.onPause);
      this.video.addEventListener('play', this.onPlay);
      document.addEventListener('visibilitychange', this.sync);
      this.motion.addEventListener('change', this.onMotionChange);
      this.observer = new IntersectionObserver(entries => {
        this.inViewport = entries.some(entry => entry.isIntersecting && entry.intersectionRatio >= 0.1);
        this.sync();
      }, { threshold: [0, 0.1] });
      this.observer.observe(this);
      this.button.hidden = false;
      this.updateButton();
    }

    shouldPlay() {
      return this.connected && this.isConnected && this.inViewport && !document.hidden &&
        !this.closest('[aria-hidden="true"], [hidden]') && !this.userPaused &&
        (!this.motion.matches || this.userStarted);
    }

    disconnectedCallback() {
      if (!this.connected) return;
      this.connected = false;
      this.observer.disconnect();
      this.button.removeEventListener('click', this.onToggle);
      this.video.removeEventListener('pause', this.onPause);
      this.video.removeEventListener('play', this.onPlay);
      document.removeEventListener('visibilitychange', this.sync);
      this.motion.removeEventListener('change', this.onMotionChange);
      this.video.pause();
    }
  });
}
